/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'Questions fréquentes - CamAPS FX',
    titleMeta: 'Vous avez une question sur CamAPS&nbsp;FX?',
    descriptionMeta: 'Voici les réponses à certaines de vos questions fréquemment posées sur les appareils compatibles, ' +
        'l’approbation réglementaire, la disponibilité et la recherche clinique',
    keywords:
        'camaps Questions fréquentes, camaps fx Questions fréquentes, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'fr_fr',

    haveQuestion: 'Vous avez une question sur CamAPS&nbsp;FX?',
    hereAnswers: 'Vous trouverez ici les réponses à la plupart des questions fréquemment posées.',
    whatIsCamAPS: 'Qu’est-ce que CamAPS&nbsp;FX?',
    whatIsCamAPSAnswer: 'CamAPS FX est une application mobile perfectionnée et facile d’emploi, destinée à gérer le taux de glucose ' +
        'chez les patients âgés de 2 ans et plus présentant un diabète de type 1, à l\'aide d\'un système sophistiqué en boucle fermée hybride qui s’adapte aux besoins en insuline..',
    isApproved: 'L’utilisation de CamAPS FX est-elle autorisée?',
    isApprovedAnswer: 'L’application a fait l’objet d’essais cliniques approfondis et son utilisation est autorisée dans plusieurs pays et régions, notamment en Australie, au Canada, dans l’Union européenne, en Nouvelle-Zélande, en Norvège, en Suisse, au Royaume-Uni et aux États-Unis.',
    isAvailable: 'CamAPS FX est-il disponible près de chez moi?',
    isAvailableAnswer1: 'CamAPS FX est disponible dans certaines cliniques spécialisées en diabète. Veuillez vérifier auprès de votre clinique.',
    isAvailableAnswer2: '',
    isAvailableAnswer3: '',
    whatIsLiberty: 'Qu’est-ce que CamAPS Liberty ?',
    whatIsLibertyAnswer: 'CamAPS Liberty est une fonctionnalité de CamAPS FX. Lorsqu’elle est activée, les utilisateurs n’ont pas besoin de compter les glucides ni d’administrer un bolus avant les repas et les collations.',
    whatIsLibertyMoreInfo1: 'Pour en savoir plus, consultez notre ',
    whatIsLibertyPageLink: 'page CamAPS Liberty',
    whatIsLibertyMoreInfo2: ' ou téléchargez cette ',
    whatIsLibertyFactsheetLink: 'fiche d’information',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: '#',
    cost: 'Combien coûte CamAPS&nbsp;FX?',
    costAnswer1: 'Pour les détails tarifaires, veuillez consulter la section',
    costAnswer2: 'du site.',
    compatibleCgm: 'Quels sont les glucomètres compatibles avec CamAPS FX ?',
    compatibleCgmBody: 'CamAPS FX est compatible avec les modèles Dexcom G6, FreeStyle Libre 3 et FreeStyle Libre 3 Plus. Veuillez cliquer sur les liens pour consulter la liste des smartphones et des systèmes d\'exploitation compatibles.',
    whatPumps: 'Quelles pompes à insuline sont compatibles avec CamAPS FX ?',
    whatPumpsAnswer1: 'CamAPS FX est compatible avec les pompes à insuline YpsoPump et est disponible sur Google Play et l\'App Store d\'Apple.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: '',
    whatPhone: 'Quels sont les smartphones compatibles avec CamAPS FX ?',
    whatPhoneAnswer: '',
    cgmManufacturerListText: '',
    whatPhoneListAnswer1: '',
    whatPhoneListAnswer2: 'Cliquer ici',
    whatPhoneListAnswer3: ' pour consulter la liste des smartphones compatibles.',
    whatOperating: 'Quels sont les systèmes d\'exploitation compatibles avec CamAPS FX ?',
    whatOperatingAnswer: '',
    whatOperatingManufacturerText: '',
    whatOperatingListAnswer1: '',
    whatOperatingListAnswer2: 'Cliquer ici',
    whatOperatingListAnswer3: ' pour consulter la liste des systèmes d\'exploitation compatibles.',
    caCompatibilityListHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/APCam-FX-D51a-RevE-Supported%20Devices%20Register_CA.pdf',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerLibreHtml:'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/APCam-FX-D51a-RevE-Supported%20Devices%20Register_CA.pdf',

    whereUpload: 'Où puis-je téléverser mes données à partir de CamAPS&nbsp;FX?',
    whereUploadAnswer: 'Actuellement, les données de CamAPS FX peuvent être téléversées sur mylife Cloud et Glooko.',
    whatLanguage: 'Quelles sont les langues prises en charge par CamAPS&nbsp;FX?',
    whatLanguageAnswer: 'CamAPS  FX est disponible en français et en anglais pour les utilisateurs canadiens.',
    whereResults: 'Où puis-je trouver les résultats de vos études cliniques?',
    whereResultsAnswer1: 'Les publications concernant l’utilisation de l’algorithme de contrôle de Cambridge sont disponibles en téléchargement',
    whereResultsAnswer2: 'ici',
    whereResultsAnswer3: '. Les articles clés ont été publiés dans',
    whereResultsAnswer4: 'et',

    wantMoreInfoIOS: 'Vous souhaitez en savoir plus sur l’application CamAPS FX pour iOS?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Cliquez ici',
    wantMoreInfoIOSanswer3: ' pour en savoir plus.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_fr_CA_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_FR_CA_DexFSL.pdf',

};
